module.exports = __webpack_public_path__ + "static/media/caja3.71533ad7.jpg";